"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _IconButton = _interopRequireDefault(require("../../../IconButton"));
var _Stack = _interopRequireDefault(require("../../../Stack"));
var _utils = require("../../utils");
var _Icon = require("../../../Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ArrowSwitcher = function ArrowSwitcher(_ref) {
  var children = _ref.children,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    onLeftClick = _ref.onLeftClick,
    onRightClick = _ref.onRightClick,
    date = _ref.date,
    _ref$leftArrowIcon = _ref.leftArrowIcon,
    leftArrowIcon = _ref$leftArrowIcon === void 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.ArrowBackIosNewIcon, {}) : _ref$leftArrowIcon,
    leftArrowLabel = _ref.leftArrowLabel,
    _ref$rightArrowIcon = _ref.rightArrowIcon,
    rightArrowIcon = _ref$rightArrowIcon === void 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.ArrowForwardIosIcon, {}) : _ref$rightArrowIcon,
    rightArrowLabel = _ref.rightArrowLabel;
  var leftDisabled = (0, _react.useMemo)(function () {
    return !(0, _utils.isBefore)(minDate, date);
  }, [minDate, date]);
  var rightDisabled = (0, _react.useMemo)(function () {
    return !(0, _utils.isAfter)(maxDate, date);
  }, [maxDate, date]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
    direction: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
      icon: leftArrowIcon,
      onClick: onLeftClick,
      disabled: leftDisabled,
      tooltip: leftArrowLabel,
      "data-cy-role": 'prev',
      size: "large"
    }), children, /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
      icon: rightArrowIcon,
      onClick: onRightClick,
      disabled: rightDisabled,
      tooltip: rightArrowLabel,
      "data-cy-role": 'next',
      size: "large"
    })]
  });
};
var _default = exports["default"] = ArrowSwitcher;